import { buildApiCall } from '@he-novation/config/apis/api-fetch';
import {
    API_TOKEN_PROJECT_DROP_FOLDER,
    API_TOKEN_RECURSIVE_CONTENT
} from '@he-novation/config/apis/token-api';
import type { AssetUploadCompleteBody } from '@he-novation/config/types/payloads/asset.payload';
import type { FileCreateBody } from '@he-novation/config/types/payloads/file.payload';

export const asyncRecursiveCastContentTokenCreate = (
    castUid: string,
    castFolderUuid?: string,
    password?: string,
    recursive?: boolean
) =>
    buildApiCall(API_TOKEN_RECURSIVE_CONTENT.POST_CAST)({
        params: {
            castUid
        },
        query: {
            castFolderUuid,
            p: password,
            recursive
        }
    });

export function asyncFindProjectWithProjectDropFolderToken(workspaceName: string, token: string) {
    return buildApiCall(API_TOKEN_PROJECT_DROP_FOLDER.GET)({
        params: {
            workspaceName,
            token
        }
    });
}

export function asyncCreateFileWithProjectDropFolderToken(
    workspaceName: string,
    token: string,
    body: FileCreateBody
) {
    return buildApiCall(API_TOKEN_PROJECT_DROP_FOLDER.POST)({
        params: {
            workspaceName,
            token
        },
        body
    });
}

export function asyncCompleteMultipartUploadWithProjectDropFolderToken(
    workspaceName: string,
    token: string,
    assetUuid: string,
    body: AssetUploadCompleteBody
) {
    return buildApiCall(API_TOKEN_PROJECT_DROP_FOLDER.PUT)({
        params: {
            assetUuid,
            workspaceName,
            token
        },
        body
    });
}
